import * as React from "react"
import type { SVGProps } from "react"
const SvgCrossroads = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M11 21.43v-3H6.83a2 2 0 0 1-1.4-.58L3.7 16.13a1 1 0 0 1-.3-.7q0-.4.3-.7L5.43 13a2 2 0 0 1 1.4-.57H11v-2H5a1 1 0 0 1-.71-.29A1 1 0 0 1 4 9.43v-4q0-.42.29-.71A1 1 0 0 1 5 4.43h6v-1q0-.42.29-.71a1 1 0 0 1 .71-.29q.42 0 .71.29.3.29.29.71v1h4.18a2 2 0 0 1 1.4.57l1.72 1.73q.3.3.3.7t-.3.7l-1.72 1.72a2 2 0 0 1-1.4.58H13v2h6q.42 0 .71.29.3.29.29.7v4q0 .44-.29.72a1 1 0 0 1-.71.29h-6v3q0 .42-.29.71a1 1 0 0 1-.71.29 1 1 0 0 1-.71-.29 1 1 0 0 1-.29-.71m-5-13h11.18l1-1-1-1H6zm.83 8H18v-2H6.83l-1 1z" />
  </svg>
)
export default SvgCrossroads
